import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const EMPLOYEE_BLOCKED = [
  "/admin", "/community", "/customer-community", "/operations", "/insurance", "/launch-training", "/employees",
  "/press-release", "/store", "/marketing-coach", "/section/equipment_pricing", "/section/sales_programs",
  "/section/marketing", "/section/social_media", "/section/brand_standards", "/section/updates", "/section/forms",
  "/section/safety_resources", "/prospect",
];
const FEATURE_ROUTES = [
  ["/sales-coach/quote-builder", "quote_builder"], ["/sales-coach/door-quote", "quote_builder"], ["/sales-coach", "sales_coach"],
  ["/ai-assistant", "ai"], ["/ai-cleaning-coach", "ai"], ["/my-presets", "my_presets"], ["/laser-machines", "my_presets"], ["/cleaning-settings", "my_presets"],
  ["/playbook", "playbook"], ["/franchise-success-guide", "success_guide"], ["/health-check", "health_check"], ["/video-studio", "video_studio"],
];
const under = (path, p) => path === p || path.startsWith(`${p}/`);

export const EmployeeRouteGuard = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading || !user || user.role !== "franchisee_employee") return;
    const feats = user.employee_features || {};
    const hit = FEATURE_ROUTES.find(([p]) => under(pathname, p));
    if (EMPLOYEE_BLOCKED.some((p) => under(pathname, p)) || (hit && feats[hit[1]] === false)) navigate("/dashboard", { replace: true });
  }, [user, loading, pathname, navigate]);
  return null;
};
